module.exports = __webpack_public_path__ + "static/img/rome.51211f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/rome.jpg
// module id = ioLf
// module chunks = 1